import React from 'react';
import { Slider, AnniversarySection, ReviewCarousel } from '../Component';
import './Home.css';
import Category from '../Component/Category/category';
import WeadingCategory from '../Component/Category/WeadingCategory';
import BirthdayHomeSection from '../Component/Birthday/index'
import WeddingHomeSection from '../Component/Wedding/index'
import Features from '../Component/Features/Features'
const Home = ({ onNavigate }) => {
  return (
    <main className="main-content">
      <div className="slider-section">
        <Slider />
      </div>
      <Category onNavigate={onNavigate} />
      <BirthdayHomeSection onNavigate={onNavigate} />
      <WeadingCategory />
      <AnniversarySection onNavigate={onNavigate} />
      <Features />
      <WeddingHomeSection onNavigate={onNavigate} />
      <ReviewCarousel />
    </main>
  );
};

export default Home;
